import styled from 'styled-components';
import { ThumbnailScroller } from '../styles';

interface MessageProps {
	isMobile?: boolean;
}

export const Base = styled.div<MessageProps>`
	position: relative;
	width: calc(100% - 68px);
	margin: 8px;
	margin-left: 36px;
	align-self: flex-end;
`;

export const Bubble = styled.div<MessageProps>`
	padding: 10px;
	padding-bottom: 12px;
	padding-left: 14px;
	font-size: ${({ isMobile }) => (isMobile ? '16px' : '13px')};
	line-height: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	border-radius: 18px;
	border-bottom-right-radius: 0px;
`;

export const Thumbnails = styled(ThumbnailScroller)`
	margin-bottom: 12px;
`;

export const Attachments = styled(ThumbnailScroller)`
	gap: 12px;
	padding-top: 1px;
	margin-bottom: 4px;
`;

export const DsPicks = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-wrap: wrap;
	padding-bottom: 8px;
	margin-left: -2px;
`;

export const ActionBar = styled.div`
	position: absolute;
	bottom: -18px;
	right: 4px;
	display: flex;
	gap: 4px;
	align-items: center;
	opacity: 0;
	transition: opacity 0.1s ease;

	${Base}:hover & {
		opacity: 1;
	}
`;

export const CopyButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	padding: 8px 7px;
	border-radius: 6px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[600]};
	font-size: 11px;
	transition: background 0.15s, border-color 0.15s;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
		border-color: ${({ theme }) => theme.gray[400]};
	}
`;
